import { Expression } from "../../bools/Expression";
import { MultiString } from "../../i18n/MultiString";
import { WebAppProject } from "../project/WebAppProject";
import { AppCommandContext } from "./AppCommandContext";
import { AppCommandBindingEntry } from "./AppCommandBindingEntry";
import { AppConditionVariable } from "./AppConditionVariable";
import { AppCommandsManager } from "./AppCommandsManager";
import { App } from "../../app/App";

export abstract class AppCommand
{
  constructor( appManager:AppCommandsManager<any,any> )
  {
    AppCommandsManager._addCommands( appManager, [ this ] );
    this.initialize();   
  }

  abstract initialize():void;

  protected _name:MultiString;
  get name(){ return this._name;}

  protected _info:MultiString;
  get info(){ return this._info }

  protected _condition:AppConditionVariable|Expression<any> = null;
  get condition(){ return this._condition;}

  protected _shortCutEntries:AppCommandBindingEntry[] = [];
  get shortCutEntries(){ return this._shortCutEntries }

  protected _commandsManager:AppCommandsManager<any,any>;
  get manager(){ return this._commandsManager }
  
  protected abstract _execute( commandContext:AppCommandContext<any,any> ):Promise<void>;
    
  run()
  {
    this._execute( AppCommandsManager._createContext( this ) );
  }

  static _addToCommandManager( appCommand:AppCommand, commandsManager:AppCommandsManager<any,any> )
  { 
    appCommand._commandsManager = commandsManager;
  }
}